/**
 * Pantalla de acceso del panel administrativo.
 *
 * Nota técnica:
 * - consulta la colección `admins` en Firestore,
 * - compara la contraseña hasheada con SHA1,
 * - y guarda una bandera de sesión local para habilitar la UI admin.
 */
import React, { useState } from "react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import sha1 from "crypto-js/sha1"; // Para hashear la contraseña con SHA1
import "./LoginAdmin.scss";

const LoginAdmin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const db = getFirestore();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Filtrar la colección "admins" por "mail" == email
      const q = query(collection(db, "admins"), where("mail", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const adminData = querySnapshot.docs[0].data();
        const hashedPassword = sha1(password).toString();

        if (hashedPassword === adminData.password) {
          // Marca admin como logueado (opcional)
          localStorage.setItem("isAdminLogged", "true");
          navigate("/dashboard-admin");
        } else {
          setError("Contraseña incorrecta");
        }
      } else {
        setError("Administrador no encontrado");
      }
    } catch (err) {
      setError("Ocurrió un error al iniciar sesión");
      console.error(err);
    }
  };

  return (
    <div className="login-admin-container">
      <h2>Login de Administrador</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Contraseña:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Iniciar sesión</button>
      </form>
    </div>
  );
};

export default LoginAdmin;
